import { styled } from '@mui/material/styles';
import Modal from '@mui/material/Modal';

export const ModalContainer = styled(Modal)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const Container = styled('div')({
  backgroundColor: 'var(--color_lvl_-5)',
  padding: 48,
  outlineWidth: 0,
  textAlign: 'center',
  width: 796,
  '& .ConnH4Lvl5L': {
    marginTop: 40,
    textTransform: 'uppercase',
  },
  '& .ConnBulletsLVL-5': {
    marginTop: 8,
  },
  '& button': {
    border: 'solid 1px var(--color_lvl_2)',
    borderRadius: 4,
    display: 'flex',
    margin: '40px auto 0',
    padding: 16,
    textTransform: 'uppercase',
    width: 400,
    '&:focus, &:hover, &.nav-selected': {
      backgroundColor: 'var(--color_lvl_3)',
      color: 'var(--color_lvl_-5)',
      textDecoration: 'none',
      transform: 'scale(1.1)',
      div: {
        color: 'var(--color_lvl_-5)',
      },
    },
  },
});

export const NonClickableLink = styled('span')({
  color: 'var(--color_primaryaccent_DKMD)',
});
